import { render, staticRenderFns } from "./ExchangeFooter.vue?vue&type=template&id=5961b6b4&scoped=true"
import script from "./ExchangeFooter.vue?vue&type=script&lang=js"
export * from "./ExchangeFooter.vue?vue&type=script&lang=js"
import style0 from "./ExchangeFooter.vue?vue&type=style&index=0&id=5961b6b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5961b6b4",
  null
  
)

export default component.exports